import {
  // Input,
  Select,
  Autocomplete,
  BankAccountInput,
} from '@new-components/elements';
import { useFormContext } from '@hooks/react-hook-form';
import {
  ApplicationDataResponse,
  useRGetApplicationData,
} from '@repositories/new-application';

import ApplicationCard from '../../../../../application-card';
import SectionTitle from '../../../../../section-title';

import { AccountInformationProps } from './types';
import { useMemo } from 'react';

export const BankAccountForm = ({
  isError,
  refetchData,
  readonly,
  loading,
  defaultIsVerifiedAccount,
  bankOptions,
  withNotes,
}: {
  readonly?: boolean;
  isError: boolean;
  loading: boolean;
  refetchData: () => void;
  defaultIsVerifiedAccount?: boolean;
  bankOptions: string[];
  withNotes?: boolean;
}) => {
  const {
    fieldsRef,
    watch,
    formState: { isSubmitting, isSubmitSuccessful },
    trigger,
    setValue,
  } = useFormContext();

  return (
    <>
      <Autocomplete
        ref={(e) => (fieldsRef.current['bankName'] = e)}
        disabled={readonly || loading || (isSubmitting && !isSubmitSuccessful)}
        onChange={() => {
          setValue('bankAccountNumberVerified', false);
        }}
        onFocus={() => isError && refetchData()}
        name='bankName'
        label='Nama Bank'
        placeholder='Pilih bank'
        options={bankOptions}
      />
      <BankAccountInput
        ref={(e) => (fieldsRef.current['bankAccountNumber'] = e)}
        disabled={
          readonly ||
          !watch('bankName') ||
          (isSubmitting && !isSubmitSuccessful)
        }
        name='bankAccountNumber'
        label='Nomor Rekening Pribadi'
        onChange={() => {
          if (typeof watch('bankAccountNumberVerified') !== 'undefined') {
            trigger('bankAccountNumber');
          }
          setValue('bankAccountNumberVerified', false);
        }}
        isVerified={
          readonly ??
          watch('bankAccountNumberVerified') ??
          defaultIsVerifiedAccount
        }
        isInvalid={watch('bankAccountNumberVerified')}
        isValidated={watch('bankAccountNumberVerified')}
        withNotes={withNotes}
      />
    </>
  );
};

const AccountInformation = (props: AccountInformationProps) => {
  const { readonly, defaultIsVerifiedAccount } = props;

  const {
    fieldsRef,
    formState: { isSubmitting, isSubmitSuccessful },
  } = useFormContext();

  const {
    data,
    isLoading: isLoadingGetApplicationData,
    isError: isErrorGetApplicationData,
    refetch: refetchGetApplicationData,
  } = useRGetApplicationData<ApplicationDataResponse<3>>({
    page: 3,
  });
  const bankOptions = useMemo(
    () => (data?.data?.banks || []).filter((item) => !!item),
    [data],
  );

  return (
    <ApplicationCard>
      <SectionTitle title='Informasi Rekening' />

      <BankAccountForm
        readonly={readonly}
        isError={isErrorGetApplicationData}
        refetchData={refetchGetApplicationData}
        defaultIsVerifiedAccount={defaultIsVerifiedAccount}
        loading={isLoadingGetApplicationData}
        bankOptions={bankOptions}
      />

      <Select
        ref={(e) => (fieldsRef.current['loanPurpose'] = e)}
        disabled={
          readonly ||
          isLoadingGetApplicationData ||
          (isSubmitting && !isSubmitSuccessful)
        }
        name='loanPurpose'
        label='Tujuan Pinjaman'
        placeholder='pilih'
        options={data?.data.loanPurposes}
      />
      {/* <Input
        ref={(e) => (fieldsRef.current['referalCode'] = e)}
        disabled={readonly || (isSubmitting && !isSubmitSuccessful)}
        name='referralCode'
        label='Kode Referral (Tidak Wajib)'
        placeholder={!readonly ? 'Kode Referral' : ''}
      /> */}
    </ApplicationCard>
  );
};

export default AccountInformation;
